import type { QueryFunctionContext } from '@tanstack/react-query';
import { UserService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.memberDetail>>;

export const createFetchUserDetailsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, userId }], signal }: TParams) =>
    call(() => cancelOnSignal(UserService.getUserDetails({ oid: organizationId, userId }), signal));
